
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Intro from './components/Intro';
import Services from './components/Services';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import SeoJsonLd from './components/SeoJsonLd';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <SeoJsonLd />
      <Navbar />
      <Hero />
      <Intro />
      <Services />
      <About />
      <Contact />
      <Footer />
    </div>
  );
}